import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jgazyvh8y: FaireProductEntity = {
  token: "p_5jgazyvh8y",
  type: "product",
  name: "So We Won’t Forget - Gold Vermeil Minimalist Necklace",
  brandToken: "b_7hb3sm8fsk",
  brandName: "LÚDERE",
  imageUrl:
    "https://cdn.faire.com/fastly/6e007ddb32e396f632016eb05ae7a7fd5be9f4c709fa1627299e77d0d90eace9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21ea455eccbfe4b3f625504bede9536bfff6ae1e94850c40e0dd7dae321831ad.jpeg",
    "https://cdn.faire.com/fastly/d92222418f8b319d30e28777314421cf987f440ae719c7ff3164066b70382ff1.jpeg",
    "https://cdn.faire.com/fastly/c9b65b3cb8ca6e53edc9a866fbd07aec154dbf519c4e4dc6704590a91eb901d5.jpeg",
    "https://cdn.faire.com/fastly/c19677084ba5027775b8e8ce7e2a8bb959c68512c3ac83487a083b814dfc4052.jpeg",
    "https://cdn.faire.com/fastly/d96603ac243d37a4379abed10719c9ea715992aa26fd7d1472e0ecc6adf5e72c.jpeg",
    "https://cdn.faire.com/fastly/b11e233031f700dac26345cb2aa48467c5dec53aebdea01f223c15fc17b5ff12.jpeg",
    "https://cdn.faire.com/fastly/83d2d221662edae63f48774283f8c1523735004effe36606b9a9efb497b88289.jpeg",
    "https://cdn.faire.com/fastly/ced30108f81e205b63b6e1f73af351f9e68824a3c24adf6faf85baeae73f56f3.jpeg",
    "https://cdn.faire.com/fastly/37ce266b7e8327f9facbc57ac2aa9894f6502ea48fa3bb6393b6d1c6957c826b.jpeg",
    "https://cdn.faire.com/fastly/23b28c441042e84fd5c2884209b8529a545bd18ffffff6e12828532a7a10a04f.jpeg",
    "https://cdn.faire.com/fastly/75f01a5b2247f9866ed0fa444798edb190a19d80ab07622e01930c4948a4d018.jpeg",
  ],
  priceDollars: 92.5,
  description:
    'Meet the LÚDERE Jewelry "So We Won\'t Forget Necklace". This beautiful necklace is made in 18K Gold Vermeil or 925 Sterling Silver. Gold Vermeil jewelry pieces are made with a base of 925 sterling silver and coated with a thick layer of 18K gold. This high-quality necklace is hypoallergenic, will not tarnish, and is made to last a lifetime. This square box pendant necklace on a 1mm rolo chain by designer Arielle Zella is perfect for both everyday wear and special occasions. It is adjustable to 15in, 16in, and 17in. Unique, beautiful, and sure to make a statement. \n\nLÚDERE is jewelry that inspires you to embrace your authentic self and to live life as play. Be Bold. Be Remarkable. Be You.',
  tags: [],
  msrpDollars: 185,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:30.279Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
